import * as React from "react";

export const MethylationBh4CycleKeyContent = () => (
  <>
    <g id="Key">
      <rect width={1424} height={250} fill="white" />
      <g id="Container_2">
        <g id="key-item - Gene">
          <rect x={40.5} y={66.5} width={386.748} height={183} stroke="#818181" />
          <text
            id="gene-label"
            fill="#1A1A1A"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Bold"
            fontSize={12}
            letterSpacing="2.8px"
          >
            <tspan x={52.4383} y={86.4}>
              GENETICS
            </tspan>
          </text>
          <g id="Container_3">
            <g id="Container_4">
              <g id="Container_5">
                <g id="Component 2">
                  <g id="gene-lozenge">
                    <path
                      d="M56 96.3896H72C73.9941 96.3896 75.6104 98.0059 75.6104 100V116C75.6104 117.994 73.9941 119.61 72 119.61H56C54.0059 119.61 52.3896 117.994 52.3896 116V100C52.3896 98.0059 54.0059 96.3896 56 96.3896Z"
                      fill="#E5E5E5"
                    />
                    <path
                      d="M56 96.3896H72C73.9941 96.3896 75.6104 98.0059 75.6104 100V116C75.6104 117.994 73.9941 119.61 72 119.61H56C54.0059 119.61 52.3896 117.994 52.3896 116V100C52.3896 98.0059 54.0059 96.3896 56 96.3896Z"
                      stroke="#1A1A1A"
                      strokeWidth={0.778643}
                    />
                  </g>
                </g>
                <text
                  id="Description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.0723} y={112.767}>
                    Not included in panel
                  </tspan>
                </text>
              </g>
              <g id="Container_6">
                <g id="Component 2_2">
                  <g id="gene-lozenge_2">
                    <path
                      d="M52 128C52 125.791 53.7909 124 56 124H72C74.2091 124 76 125.791 76 128V144C76 146.209 74.2091 148 72 148H56C53.7909 148 52 146.209 52 144V128Z"
                      fill="#CCBAFF"
                    />
                  </g>
                </g>
                <text
                  id="Description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2559} y={140.767}>
                    No read
                  </tspan>
                </text>
              </g>
              <g id="Container_7">
                <g id="Component 2_3">
                  <g id="snp-indicator">
                    <path
                      id="Polygon 3"
                      d="M63.3387 158.372C63.6326 157.876 64.3674 157.876 64.6613 158.372L70.8966 168.885C71.1905 169.381 70.8231 170 70.2352 170H57.7648C57.1769 170 56.8095 169.381 57.1034 168.885L63.3387 158.372Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.1738} y={168.767}>
                    Increased activity
                  </tspan>
                </text>
              </g>
              <g id="Container_8">
                <g id="Component 2_4">
                  <g id="snp-indicator_2">
                    <path
                      id="Polygon 3_2"
                      d="M64.6613 197.628C64.3674 198.124 63.6326 198.124 63.3387 197.628L57.1034 187.115C56.8095 186.619 57.1769 186 57.7648 186L70.2352 186C70.8231 186 71.1905 186.619 70.8966 187.115L64.6613 197.628Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_4"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2285} y={196.767}>
                    Decreased activity
                  </tspan>
                </text>
              </g>
            </g>
            <g id="Container_9">
              <g id="Container_10">
                <g id="Component 2_5">
                  <g id="gene-lozenge_3">
                    <path
                      d="M237 100C237 97.7909 238.791 96 241 96H257C259.209 96 261 97.7909 261 100V116C261 118.209 259.209 120 257 120H241C238.791 120 237 118.209 237 116V100Z"
                      fill="#00BF86"
                    />
                  </g>
                </g>
                <text
                  id="Risk description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.288} y={112.767}>
                    0 risk alleles
                  </tspan>
                </text>
              </g>
              <g id="Container_11">
                <g id="Component 2_6">
                  <g id="gene-lozenge_4">
                    <path
                      d="M237 128C237 125.791 238.791 124 241 124H257C259.209 124 261 125.791 261 128V144C261 146.209 259.209 148 257 148H241C238.791 148 237 146.209 237 144V128Z"
                      fill="#FF905F"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.271} y={140.767}>
                    1 risk allele
                  </tspan>
                </text>
              </g>
              <g id="Container_12">
                <g id="Component 2_7">
                  <g id="gene-lozenge_5">
                    <path
                      d="M237 156C237 153.791 238.791 152 241 152H257C259.209 152 261 153.791 261 156V172C261 174.209 259.209 176 257 176H241C238.791 176 237 174.209 237 172V156Z"
                      fill="#FF5D6D"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.006} y={168.767}>
                    2 risk alleles
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="key-item - Not included">
            <g id="Icon">
              <path
                id="*"
                d="M63.7483 224.79V227.209L59.8178 227.08L62.0638 230.319L59.861 231.615L57.8741 228.116L55.8873 231.615L53.6845 230.319L55.9305 227.08L52 227.209L52 224.79L55.9305 224.92L53.6845 221.681L55.8873 220.385L57.8741 223.883L59.861 220.385L62.0638 221.681L59.8178 224.92L63.7483 224.79Z"
                fill="black"
              />
            </g>
            <text
              id="Explanation"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={73.748} y={230.086}>
                Limited / insufficient evidence for interpretation in this context
              </tspan>
            </text>
          </g>
        </g>
        <g id="Container_13">
          <g id="key-item - co factor">
            <g id="Cofactor">
              <g id="diamond">
                <g id="Vector">
                  <mask id="path-22-inside-1_18291_211490" fill="white">
                    <path d="M476.748 66L497.748 76.1818V97.8182L476.748 108L455.748 97.8182V76.1818L476.748 66Z" />
                  </mask>
                  <path
                    d="M476.748 66L497.748 76.1818V97.8182L476.748 108L455.748 97.8182V76.1818L476.748 66Z"
                    stroke="#1A1A1A"
                    strokeWidth={2}
                    mask="url(#path-22-inside-1_18291_211490)"
                  />
                </g>
              </g>
            </g>
            <text
              id="Cofactor_2"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={507.749} y={91.767}>
                Cofactor
              </tspan>
            </text>
          </g>
          <g id="key-item - affect">
            <g id="lines">
              <path
                id="Vector_2"
                d="M593.448 86.3C593.062 86.3 592.748 86.6134 592.748 87C592.748 87.3866 593.062 87.7 593.448 87.7V87V86.3ZM647.748 87L640.748 82.9585V91.0415L647.748 87ZM595.388 87.7C595.774 87.7 596.088 87.3866 596.088 87C596.088 86.6134 595.774 86.3 595.388 86.3V87V87.7ZM599.266 86.3C598.88 86.3 598.566 86.6134 598.566 87C598.566 87.3866 598.88 87.7 599.266 87.7V87V86.3ZM603.145 87.7C603.531 87.7 603.845 87.3866 603.845 87C603.845 86.6134 603.531 86.3 603.145 86.3V87V87.7ZM607.023 86.3C606.637 86.3 606.323 86.6134 606.323 87C606.323 87.3866 606.637 87.7 607.023 87.7V87V86.3ZM610.902 87.7C611.288 87.7 611.602 87.3866 611.602 87C611.602 86.6134 611.288 86.3 610.902 86.3V87V87.7ZM614.78 86.3C614.394 86.3 614.08 86.6134 614.08 87C614.08 87.3866 614.394 87.7 614.78 87.7V87V86.3ZM618.659 87.7C619.046 87.7 619.359 87.3866 619.359 87C619.359 86.6134 619.046 86.3 618.659 86.3V87V87.7ZM622.538 86.3C622.151 86.3 621.838 86.6134 621.838 87C621.838 87.3866 622.151 87.7 622.538 87.7V87V86.3ZM626.416 87.7C626.803 87.7 627.116 87.3866 627.116 87C627.116 86.6134 626.803 86.3 626.416 86.3V87V87.7ZM630.295 86.3C629.908 86.3 629.595 86.6134 629.595 87C629.595 87.3866 629.908 87.7 630.295 87.7V87V86.3ZM634.173 87.7C634.56 87.7 634.873 87.3866 634.873 87C634.873 86.6134 634.56 86.3 634.173 86.3V87V87.7ZM638.052 86.3C637.665 86.3 637.352 86.6134 637.352 87C637.352 87.3866 637.665 87.7 638.052 87.7V87V86.3ZM641.93 87.7C642.317 87.7 642.63 87.3866 642.63 87C642.63 86.6134 642.317 86.3 641.93 86.3V87V87.7ZM645.809 86.3C645.422 86.3 645.109 86.6134 645.109 87C645.109 87.3866 645.422 87.7 645.809 87.7V87V86.3ZM593.448 87V87.7H595.388V87V86.3H593.448V87ZM599.266 87V87.7H603.145V87V86.3H599.266V87ZM607.023 87V87.7H610.902V87V86.3H607.023V87ZM614.78 87V87.7L618.659 87.7V87V86.3L614.78 86.3V87ZM622.538 87V87.7H626.416V87V86.3H622.538V87ZM630.295 87V87.7H634.173V87V86.3H630.295V87ZM638.052 87V87.7H641.93V87V86.3H638.052V87Z"
                fill="#E44C4B"
              />
            </g>
            <text
              id="Affect"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={657.785} y={91.767}>
                Negative impact
              </tspan>
            </text>
          </g>
          <g id="key-item - Affect 3">
            <g id="Frame 472">
              <rect
                x={794.448}
                y={75.7}
                width={46.6}
                height={22.6}
                stroke="#5220DD"
                strokeWidth={1.4}
                strokeDasharray="2.8 2.8"
              />
            </g>
            <text
              id="Affect_2"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={852.211} y={91.767}>
                Outcome
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </g>
  </>
);

const SvgMethylationBh4CycleKey = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1424}
    height={250}
    viewBox="0 0 1424 250"
    fill="none"
    {...props}
  >
    <MethylationBh4CycleKeyContent />
  </svg>
);

export default SvgMethylationBh4CycleKey;
